import React, { useEffect, useState } from 'react';
import { useGlobalContext } from '../../components/GlobalContextProvider/GlobalContextProvider';
import Header from '../../components/Header/Header';
import {
  GradientContainer,
  Message,
  HomeButton,
  SmallMessage,
} from '../../shared-styled/blocks/errorPagesBlocks';
import {
  BasePageContainer,
  ChildrenWrapper,
} from '../BasePage/BasePage.styled';
import NavigationPage from '../NavigationPage/NavigationPage';

const Page304 = () => {
  const { isNavActive } = useGlobalContext();
  const [seconds, setSeconds] = useState(3);

  useEffect(() => {
    const lastReloadTimestamp = window.localStorage.getItem(
      'lastReloadTimestamp',
    );

    if (!lastReloadTimestamp) {
      return;
    }

    const now = Date.now();
    const timeSinceLastReload = lastReloadTimestamp
      ? now - parseInt(lastReloadTimestamp, 10)
      : 0;

    const additionalSeconds = timeSinceLastReload < 10000 ? 7 : 0;
    setSeconds(3 + additionalSeconds);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else {
        clearInterval(interval);
        window.localStorage.setItem(
          'lastReloadTimestamp',
          Date.now().toString(),
        );
        window.location.reload();
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const reloadPage = () => {
    if (!window) {
      return;
    }

    window.localStorage.removeItem('lastReloadTimestamp');
    window.location.reload();
  };

  return (
    <BasePageContainer>
      <Header />
      {isNavActive ? (
        <NavigationPage isNotFoundPage={true} />
      ) : (
        <ChildrenWrapper>
          <GradientContainer>
            <Message>Please wait, the page is still loading...</Message>
            <SmallMessage>{`The page will be reloaded in ${seconds}`}</SmallMessage>
            <HomeButton onClick={reloadPage}>Reload now</HomeButton>
          </GradientContainer>
        </ChildrenWrapper>
      )}
    </BasePageContainer>
  );
};

export default Page304;
